export default "__VITE_ASSET__CPsidVIy__"